import classNames from 'classnames';
import React from 'react';
import BorderedIcon from '../components/BorderedIcon';
import SVGIcon from '../components/SVGIcon';
import verifiedIcon from '../icons/prefilled/verified.svg';
import styles from './VerifiedIcon.module.scss';

type SVGIconProps = React.ComponentProps<typeof SVGIcon>;

interface VerifiedIconProps extends SVGIconProps {
  bordered?: boolean;
  variant?: 'success' | 'warning' | 'muted';
}

const VerifiedIcon = ({
  bordered = false,
  variant = 'success',
  ...svgIconProps
}: VerifiedIconProps) => {
  const Icon = bordered ? BorderedIcon : SVGIcon;
  return (
    <Icon
      coloringWith="fill"
      className={classNames({
        [styles.success]: variant === 'success',
        [styles.warning]: variant === 'warning',
        [styles.muted]: variant === 'muted',
      })}
      {...svgIconProps}
    >
      {verifiedIcon}
    </Icon>
  );
};

export default VerifiedIcon;
